import { c as _c } from "react/compiler-runtime";
export const EmptyScrapList = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <article className="flex flex-1 items-center justify-center"><p className="font-400 text-Gray-600 typo-body3">아직 스크랩한 글이 없어요</p></article>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};